module.exports = __webpack_public_path__ + "img/hr-heated-t-down-1.4999905b.png";